import { render } from "./InputCheckbox.vue?vue&type=template&id=4b96d1c0"
import script from "./InputCheckbox.vue?vue&type=script&lang=js"
export * from "./InputCheckbox.vue?vue&type=script&lang=js"

import "./InputCheckbox.vue?vue&type=style&index=0&id=4b96d1c0&lang=scss"
script.render = render

export default script